import { ImagePlus, Trash2, Upload } from "lucide-react";
import { useRef } from "react";
import { Button } from "../../../../components/ui/common/button";

interface IngredientImageUploadProps {
  imagePath: string;
  onUpload: (file: File | null) => void;
  onDelete: () => void;
}

/**
 * Tailwind-native ingredient image upload — preview box + upload/delete
 * buttons, no Semantic UI (replaces the legacy `NewImageUploader`, which
 * still pulls in `Icon` from `semantic-ui-react`).
 */
const IngredientImageUpload = ({ imagePath, onUpload, onDelete }: IngredientImageUploadProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="tw-flex tw-items-center tw-gap-4">
      <div className="tw-flex tw-h-16 tw-w-16 tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-md tw-border tw-border-dashed tw-border-border tw-bg-muted/40">
        {imagePath ? (
          <img src={imagePath} alt="Ingredient" className="tw-h-full tw-w-full tw-object-cover" />
        ) : (
          <ImagePlus className="tw-h-5 tw-w-5 tw-text-muted-foreground" />
        )}
      </div>
      <div className="tw-flex tw-gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => inputRef.current?.click()}
        >
          <Upload className="tw-h-4 tw-w-4" />
          Upload ingredient image
        </Button>
        {imagePath ? (
          <Button type="button" variant="outline" size="sm" onClick={onDelete}>
            <Trash2 className="tw-h-4 tw-w-4" />
          </Button>
        ) : null}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="tw-hidden"
        onChange={e => {
          onUpload(e.target.files?.[0] || null);
          e.target.value = "";
        }}
      />
    </div>
  );
};

export default IngredientImageUpload;
